// Generated by BUCKLESCRIPT VERSION 2.2.0, PLEASE EDIT WITH CARE
'use strict';

var Model = require("./model");
var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var component = ReasonReact.statelessComponent("SortEnSeance");

function make(sortEnSeance, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      var tmp;
      switch (sortEnSeance) {
        case 0 : 
            tmp = "Adopté";
            break;
        case 1 : 
            tmp = "À discuter";
            break;
        case 2 : 
            tmp = "Non soutenu";
            break;
        case 3 : 
            tmp = "Rejeté";
            break;
        case 4 : 
            tmp = "Retiré";
            break;
        case 5 : 
            tmp = "Tombé";
            break;
        
      }
      return React.createElement("mark", {
                  style: {
                    backgroundColor: sortEnSeance !== 1 ? (
                        sortEnSeance !== 0 ? "#d0021b" : "#4caf50"
                      ) : "grey",
                    color: "white",
                    fontSize: "16px",
                    marginLeft: "10px",
                    padding: "5px 5px 5px 5px",
                    flex: "1 1 auto"
                  }
                }, Model.ste(tmp));
    });
  return newrecord;
}

exports.component = component;
exports.make = make;
/* component Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/sortEnSeance.re
// module id = 179
// module chunks = 0